import trex from '../assets/dinosarus/Tyrannosaurus Rex/trex_painting.jpg'
import spinosaurus from '../assets/dinosarus/spinosaurs/spinosaurus.jpeg'
import stegosaurus from '../assets/dinosarus/Stegosaurus/stegosaurus.jpg'
import triceratops from '../assets/dinosarus/Triceratops/triceratpos_painting.jpg'
import velociraptor from '../assets/dinosarus/velociraptor/velociraptor_paint.jpg'
import brachiosaurus from '../assets/dinosarus/Brachiosaurus/brachiosaurus.jpg'
import pteranodon from '../assets/dinosarus/Pteranodon/pteranondon_painting.jpeg'
import mapBackgroundImage from '../assets/map/new_map_compressed.jpg'
// MissionBriefing (instructions) page images
import missionBriefingBg from '../assets/instruction_page/background_img.jpg'
import hunterSilhouette from '../assets/instruction_page/human_black_2.png'

// Mock data for Jurassic Park Game

export const gameData = {
  worldName: "DRE",
  totalDinosaurs: 7,
  challenges :{},
  
  locations: [
    {
      id: 1,
      name: "Volcanic Mountains",
      dinosaur: "T-Rex",
      weapon: "Tranquilizer Cannon",
      position: { top: '1%', left: '15%' },
      backgroundImage: 'https://images.unsplash.com/photo-1609718581760-e7518a038f32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwcmVoaXN0b3JpYyUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3NjI1MjM0MDV8MA&ixlib=rb-4.1.0&q=85',
      dinosaurImage: trex,
      challengeDescription: 'Write a Deluge function to calculate the optimal tranquilizer dosage for a T-Rex based on weight and aggression level.',
      defaultCode: '// Write your Deluge function here\n// Function should accept weight and aggression parameters\n\nfunction calculateDosage(weight, aggression) {\n  // Your code here\n  \n}'
    },
    {
      id: 2,
      name: "Dense Rainforest",
      dinosaur: "Velociraptor",
      weapon: "Steel Net",
      position: { top: '15%', left: '50%' },
      backgroundImage: 'https://images.unsplash.com/photo-1495544271064-3764df937987?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxqdW5nbGUlMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzYyNTIzMzk0fDA&ixlib=rb-4.1.0&q=85',
      dinosaurImage:velociraptor,
      challengeDescription: 'Create a Deluge function to determine the net trajectory angle for capturing a fast-moving Velociraptor.',
      defaultCode: '// Write your Deluge function here\n// Calculate net trajectory based on speed and distance\n\nfunction calculateTrajectory(speed, distance) {\n  // Your code here\n  \n}'
    },
    {
      id: 3,
      name: "Ancient Canyons",
      dinosaur: "Brachiosaurus",
      weapon: "Sonic Disruptor",
      position: { top: '70%', left: '40%' },
      backgroundImage: 'https://images.unsplash.com/photo-1699694927495-4b8da5df6ce5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxqdW5nbGUlMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzYyNTIzMzk0fDA&ixlib=rb-4.1.0&q=85',
      dinosaurImage: brachiosaurus,
      challengeDescription: 'Write a Deluge function to calibrate sonic frequency for a massive Brachiosaurus without harming it.',
      defaultCode: '// Write your Deluge function here\n// Calculate safe sonic frequency based on size\n\nfunction calibrateSonic(height, mass) {\n  // Your code here\n  \n}'
    },
    {
      id: 4,
      name: "Misty Waterfalls",
      dinosaur: "Triceratops",
      weapon: "Electromagnetic Gun",
      position: { top: '10%', left: '90%' },
      backgroundImage: 'https://images.unsplash.com/photo-1661792218910-94b817737227?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxqdW5nbGUlMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzYyNTIzMzk0fDA&ixlib=rb-4.1.0&q=85',
      dinosaurImage: triceratops,
      challengeDescription: 'Create a Deluge function to generate the correct EMP pulse duration to stun a Triceratops.',
      defaultCode: '// Write your Deluge function here\n// Calculate EMP pulse duration\n\nfunction calculateEMP(resistance, targetArea) {\n  // Your code here\n  \n}'
    },
    {
      id: 5,
      name: "Marshy Swamps",
      dinosaur: "Spinosaurus",
      weapon: "Cryo Freezer Gun",
      position: { top: '65%', left: '80%' },
      backgroundImage: 'https://images.unsplash.com/photo-1699694927257-89ac5ce509a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxqdW5nbGUlMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzYyNTIzMzk0fDA&ixlib=rb-4.1.0&q=85',
      dinosaurImage: spinosaurus,
      challengeDescription: 'Write a Deluge function to calculate the cryo temperature needed to freeze a Spinosaurus in swamp conditions.',
      defaultCode: '// Write your Deluge function here\n// Calculate cryo temperature\n\nfunction calculateCryoTemp(ambientTemp, humidity) {\n  // Your code here\n  \n}'
    },
    {
      id: 6,
      name: "Bushland Fire",
      dinosaur: "Stegosaurus",
      weapon: "Taser Grid",
      position: { top: '75%', left: '102%' },
      backgroundImage: 'https://images.unsplash.com/photo-1603879188863-1e2ad8397a17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHx3b3JsZCUyMG1hcCUyMHRlcnJhaW58ZW58MHx8fHwxNzYyNTIzMzg4fDA&ixlib=rb-4.1.0&q=85',
      dinosaurImage: stegosaurus,
      challengeDescription: 'Create a Deluge function to configure the taser grid voltage for a Stegosaurus with armored plates.',
      defaultCode: '// Write your Deluge function here\n// Calculate taser grid voltage\n\nfunction configureVoltage(armorThickness, bodyMass) {\n  // Your code here\n  \n}'
    },
    {
      id: 7,
      name: "Frozen Tundra",
      dinosaur: "Pteranodon",
      weapon: "Sky Net Drone",
      position: { top: '0.1%', left: '105%' },
      backgroundImage: 'https://images.unsplash.com/photo-1609718581760-e7518a038f32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwcmVoaXN0b3JpYyUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3NjI1MjM0MDV8MA&ixlib=rb-4.1.0&q=85',
      dinosaurImage: pteranodon,
      challengeDescription: 'Write a Deluge function to calculate drone flight path to intercept a flying Pteranodon.',
      defaultCode: '// Write your Deluge function here\n// Calculate interception path\n\nfunction calculateFlightPath(altitude, windSpeed, targetVelocity) {\n  // Your code here\n  \n}'
    }
  ],

  introVideo: {
    placeholder: 'https://images.unsplash.com/photo-1579197073550-bf44b469a6fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkaW5vc2F1ciUyMGVzY2FwZXxlbnwwfHx8fDE3NjI1MjM0MDB8MA&ixlib=rb-4.1.0&q=85',
    title: 'The Escape Begins',
    description: 'Video will show how the 7 dinosaurs escaped from their enclosures in world DRE'
  },

  instructions: [
    'Welcome to DRE World, a once peaceful place where chaos has now broken loose.',
    'Seven dangerous dinosaurs have escaped their secure enclosures and are now scattered across the world.',
    'Your mission is to capture them all and return them safely to their cages.',
    'Each dinosaur can only be captured using a specific weapon.',
    'These weapons are hidden across seven different regions around the world.',
    'To unlock a weapon, you must solve a Deluge programming challenge.',
    'You may approach and capture the dinosaurs in any order you choose.',
    'Good luck. May your Deluge skills restore order to DRE World.'
  ]
};

// Progress management
export const getGameProgress = async (forceRefresh = false) => {
  // Always fetch fresh data from API - no static variables or caching
  const saved = await mockApiCalls.loadChallenges();
  return JSON.parse(saved);
};

export const saveGameProgress = (progress) => {
  sessionStorage.setItem('jurassicGameProgress', JSON.stringify(progress));
};

export const resetGameProgress = () => {
  sessionStorage.removeItem('jurassicGameProgress');
};

// export const setGameProgress = (progress) => {
//     const already = sessionStorage.getItem('jurassicGameProgress');
//   if (saved) {
//     return JSON.parse(saved);
//   }
// }

// Category to Location mapping - hardcoded to ensure consistent positioning
export const CATEGORY_TO_LOCATION = {
  'AI': 1,            // Location 1 - Volcanic Mountains
  'SFTP': 2,          // Location 2 - Dense Rainforest
  'INTEGRATION': 3,   // Location 3 - Ancient Canyons
  'SECURITY': 4,      // Location 4 - Misty Waterfalls
  'THIRD PARTY': 5,   // Location 5 - Marshy Swamps
  'COLLECTION': 6,    // Location 6 - Bushland Fire
  'PERFORMANCE': 7    // Location 7 - Frozen Tundra
};

// Mock function for backend API calls (to be implemented later)
export const mockApiCalls = {
    getTrackingTime: async () => {
    try {
      const response = await fetch('/server/JurassicServer/getTimeTracking', {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch tracking time');
      }
      const data = await response.json();
      console.log('Tracking time fetched successfully:', data);
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching tracking time:', error);
      return { success: false };
    }
  },

  loadChallenges : async () =>{
        try {
      const response = await fetch('/server/JurassicServer/getChallenges', {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch Challenges for the ');
      }
      const res = await response.json();
      const challenges = res.questions;
      const capturedDinosaurs = [];
      const failedLocations = [];

      // Create fresh location data without mutating global gameData
      const freshLocations = gameData.locations.map(location => {
        // Map challenge to location based on category instead of order
        const challenge = challenges.find(c => CATEGORY_TO_LOCATION[c.category] === location.id);
        const freshLocation = { ...location };

        if (challenge) {
          freshLocation.challengeDescription = challenge.question;
          freshLocation.questionId = challenge.id;
          freshLocation.category = challenge.category;

          if(challenge.solved){
            capturedDinosaurs.push(location.id);
          }
          // Check for failed: attemptsLeft === 0 and not solved
          if(!challenge.solved && challenge.attemptsLeft === 0){
            failedLocations.push(location.id);
          }
        }
        return freshLocation;
      });

      // Return fresh data without storing in static variables
      res.capturedDinosaurs = capturedDinosaurs;
      res.failedLocations = failedLocations;
      res.locations = freshLocations;

      console.log('Challenges fetched successfully:', challenges);
      return JSON.stringify(res);
    } catch (error) {
      console.error('Error fetching tracking time:', error);
      return { success: false };
    }
  },

  saveProgress: async (progress) => {
    // TODO: Replace with actual API call
    // await fetch(`${API}/game/progress`, { method: 'POST', body: JSON.stringify(progress) });
    console.log('Progress saved to localStorage (backend integration pending):', progress);
    saveGameProgress(progress);
    return { success: true };
  },
  
  loadProgress: async () => {
    // TODO: Replace with actual API call
    // const response = await fetch(`${API}/game/progress`);
    // return response.json();
    console.log('Progress loaded from localStorage (backend integration pending)');
    return getGameProgress();
  },
  
  validateDelugeCode: async (location, code) => {
    const API = "/server/JurassicServer";

    try {
      const gameProgress = await getGameProgress();
      // Find challenge by category mapping instead of order
      const challenge = gameProgress.questions.find(ch => CATEGORY_TO_LOCATION[ch.category] === location.id) || {};

      const bodyJSON = {
        "location": location.id,
        "script": code,
        "questionId": challenge.id
      };

      const response = await fetch(`${API}/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        },
        cache: 'no-store',
        body: JSON.stringify(bodyJSON)
      });

      const data = await response.json();

      // Extract nested error message if present (e.g., from function execution errors)
      const extractErrorMessage = (responseData) => {
        if (responseData.error && responseData.error.message) {
          return responseData.error.message;
        }
        return responseData.message;
      };

      // If server returned error status, propagate the error message
      if (!response.ok) {
        return {
          success: false,
          message: extractErrorMessage(data) || `Server error: ${response.status}`,
          ...data
        };
      }

      // Also check for function execution failure in successful HTTP responses
      if (data.status === 'failure' || data.success === false) {
        return {
          ...data,
          success: false,
          message: extractErrorMessage(data) || data.message || 'Execution failed'
        };
      }

      return data;
    } catch (error) {
      console.error('Error submitting code:', error);
      return {
        success: false,
        message: error.message || 'Network error. Please check your connection.'
      };
    }
  },

  // Run mode - only runs non-hidden test cases, doesn't track attempts
  runDelugeCode: async (location, code) => {
    const API = "/server/JurassicServer";

    try {
      const gameProgress = await getGameProgress();
      // Find challenge by category mapping instead of order
      const challenge = gameProgress.questions.find(ch => CATEGORY_TO_LOCATION[ch.category] === location.id) || {};

      const bodyJSON = {
        "location": location.id,
        "script": code,
        "questionId": challenge.id
      };

      const response = await fetch(`${API}/run`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        },
        cache: 'no-store',
        body: JSON.stringify(bodyJSON)
      });

      const data = await response.json();

      // Extract nested error message if present (e.g., from function execution errors)
      const extractErrorMessage = (responseData) => {
        if (responseData.error && responseData.error.message) {
          return responseData.error.message;
        }
        return responseData.message;
      };

      // If server returned error status, propagate the error message
      if (!response.ok) {
        return {
          success: false,
          message: extractErrorMessage(data) || `Server error: ${response.status}`,
          ...data
        };
      }

      // Also check for function execution failure in successful HTTP responses
      if (data.status === 'failure' || data.success === false) {
        return {
          ...data,
          success: false,
          message: extractErrorMessage(data) || data.message || 'Execution failed'
        };
      }

      return data;
    } catch (error) {
      console.error('Error running code:', error);
      return {
        success: false,
        message: error.message || 'Network error. Please check your connection.'
      };
    }
  },

  // Get retry request status for current user
  getRetryStatus: async () => {
    const API = "/server/JurassicServer";
    try {
      const response = await fetch(`${API}/retryStatus`);
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to get retry status');
      }
      return data;
    } catch (error) {
      console.error('Error getting retry status:', error);
      return { success: false, status: 'NONE', requestCount: 0, message: error.message };
    }
  },

  // Submit a retry request
  requestRetryChance: async () => {
    const API = "/server/JurassicServer";
    try {
      const response = await fetch(`${API}/requestRetry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit retry request');
      }
      return data;
    } catch (error) {
      console.error('Error submitting retry request:', error);
      throw error;
    }
  }
};

// Export all images for preloading
export const getAllPreloadImages = () => [
  // MissionBriefing (instructions) page images
  missionBriefingBg,
  hunterSilhouette,
  // Map background
  mapBackgroundImage,
  // All dinosaur images
  trex, spinosaurus, stegosaurus, triceratops,
  velociraptor, brachiosaurus, pteranodon,
  // All location background images (Unsplash URLs)
  ...gameData.locations.map(loc => loc.backgroundImage),
];